import { render, staticRenderFns } from "./MasterClassNew.vue?vue&type=template&id=240f2e27&"
import script from "./MasterClassNew.vue?vue&type=script&lang=js&"
export * from "./MasterClassNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports